import * as ACTION_TYPES from './Types';

const initialState = {
  dealers:{},
  message: '',
  error: null,
}

export const dealerReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case ACTION_TYPES.GETDEALERS_SUCCESS:  
      return {
          ...state,
          dealers:action.payload.data,
          message: action.payload.message,
      }

    case ACTION_TYPES.GETDEALERS_ERROR:
      return {
        ...state,
        message: action.payload.message,
      } 
     case ACTION_TYPES.APPROVAL_SUCCESS:  
    case ACTION_TYPES.CHANGEACTION_SUCCESS:
      return {
          ...state,
          categories:action.payload.data,
          message: action.payload.message,
      }

     case ACTION_TYPES.APPROVAL_ERROR:
    case ACTION_TYPES.CHANGEACTION_ERROR:
 
      return {
        ...state,
        message: action.payload.message,
      }               
        
    default:
      return state;
  }
}
